// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme/index';
import { TABLET_SMALL_WIDTH } from 'commons/constants';

const {
  noodera: { fontTypes, spacing },
} = getTheme();
export const Wrapper: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const Container: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${spacing.x5};
  width: 100%;

  @media only screen and (min-width: ${TABLET_SMALL_WIDTH}px) {
    flex-wrap: unset;
    align-items: center;
  }
`;
export const LogoContainer: StatelessFunctionalComponent<any> = styled.div`
  height: auto;
  width: 100%;
  justify-content: center;
  display: flex;
  margin-bottom: ${spacing.x3};
  padding: 0 ${spacing.x5} ${spacing.x5} ${spacing.x5};

  img {
    max-width: 100%;
    max-height: 100%;
  }

  @media only screen and (min-width: ${TABLET_SMALL_WIDTH}px) {
    margin-bottom: unset;
    padding: 0;
    margin-right: ${spacing.x3};
    flex: 50%;
  }
`;
export const InfoContainer: StatelessFunctionalComponent<any> = styled.div`
  flex: 50%;
  width: 100%;
  max-width: 464px;
  // TODO: Temporary styles meanwhile we don't have Heading text from contentful
  display: flex;
  align-items: center;
`;
export const Title: StatelessFunctionalComponent<any> = styled.h3`
  ${fontTypes.font3Medium};
  margin-bottom: ${spacing.x3};
`;
export const Text: StatelessFunctionalComponent<any> = styled.p`
  ${fontTypes.font4Article};
`;
